<div id="no-permissions" *ngIf="!hasPermission">
  <ui-icon [uiClass]="'ui-1_lock-open'"></ui-icon>
  <h1>{{ "user_screen_permission_denied" | localize }}</h1>
  <h2>{{ "contact_admin" | localize }}</h2>
</div>

<div class="tag-form" *ngIf="hasPermission">
  <div class="gh-f-title-medium">{{ "create_new_tag" | localize }}</div>
  <div class="pt-15px" *ngIf="initialized">
    <form [formGroup]="tagForm" (ngSubmit)="save()">
      <div class="gh-no-padding gh-no-margin d-flex align-items-c">
        <div class="gh-no-padding gh-no-margin col-md-3 section-name">
          {{ "name" | localize }}
        </div>
        <div class="gh-no-padding gh-no-margin col-md-9 d-flex flex-d-c">
          <input formControlName="title" name="title" class="gh-input-text-v2" autofocus="true" data-test-id="tag-name" />
          <div class="explain-error d-inline-flex" *ngIf="tagForm.hasError('tagExists')">
            <span class="gh-font-icon-caution"></span>&nbsp;
            <span class="explain-error">{{ "tag_exists" | localize }}</span>
          </div>
        </div>
      </div>

      <div class="form-actions mt-30px mb-10px">
        <gh-indicator [ghValue]="indicators.loading" (onReset)="resetIndicator('loading')" ghMessage="{{ 'loading' | localize }}"></gh-indicator>

        <ng-container *ngIf="!indicators.loading">
          <button gh-button type="submit" class="gh-b gh-accent large primary" size="large" kind="primary" data-test-id="create-role-button" data-button="Save" [disabled]="!tagForm.valid">
            {{ "create_tag" | localize }}
          </button>
          <button gh-button class="gh-b large secondary" size="large" kind="secondary" (click)="$event.preventDefault(); cancel()">
            {{ "cancel" | localize }}
          </button>
        </ng-container>
      </div>
    </form>
  </div>
  <div class="gh-modal-close-button" (click)="cancel()">
    <ui-icon [uiClass]="'nc-icon-outline icon ui-1_simple-remove'"></ui-icon>
  </div>
  <inactive-tag-exists-modal *ngIf="inactiveTag" [isOpen]="true" [width]="500" (onClose)="clearInactiveTag()" (onActivate)="activateInactiveTag()"></inactive-tag-exists-modal>
</div>
